import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./Store";
import WidgetApp from "./WidgetApp";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <WidgetApp/>
    </Provider>
  // </React.StrictMode>
);

//* from React 18 Strict Mode renders twice only in develoment mode don't worry in production it will render only once